module.exports = __webpack_public_path__ + "static/img/4.9867ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4.png
// module id = HBbv
// module chunks = 0